export const environment = {
  production      : true,
  api             : "https://nkgdc0tts4.execute-api.us-east-1.amazonaws.com/Prod/api/",
  redirectUri     : 'https://staging-mesa-ayuda.ieeg.mx/',
  scopes          : 'api://32664ae7-44fb-4a89-a099-480f47146387/auth.activedirectory',
  ruta            : "https://api.ieeg.org.mx/EleccionesEscolares/",
  version         : "1.4.0",
  meAzure         : 'https://graph.microsoft.com/v1.0/me',
  variableEntorno : 'staging',
  serviceWorker: true
};